// Types
export * from './types';

// Constants
export { ACTIVATION_STEPS, ACTIVATION_EVENTS, SPOTLIGHT_IDS, getCurrentStepIndex, getCompletedCount } from './checklistSteps';

// Animations
export * from './animations';

// Spotlight
export { SpotlightPulse } from './SpotlightPulse';

// Hooks
export { useActivation } from './useActivation';
export { useStepClickHandler } from './useStepClickHandler';

// Components
export { ActivationChecklistItem } from './ActivationChecklistItem';
export { ActivationProgress } from './ActivationProgress';
export { AnimatedCheckIcon, CompletedCheckIcon } from './AnimatedCheckIcon';
export { CompletionView } from './CompletionView';
export {
  ActivationChecklistSwitcher,
  ActivationSidebarChecklist,
  // Deprecated: ActivationFloatingChecklist, ActivationBannerChecklist
} from './ActivationChecklistSwitcher';

// Sidebar variant (Float and Banner have been deprecated)
export { SidebarChecklist } from './variants/SidebarChecklist';
